export const GATSBY_API_HOST = "https://facade-good.ru"
// export const GATSBY_API_HOST = "http://localhost"
export const GATSBY_API_PORT = "443"
